import { DEFAULT_WIDGET_ICON_HEIGHT, DEFAULT_WIDGET_ICON_WIDTH } from 'constants/controller'
import { broadcast } from 'utils/message'

enum FrameToggleAction {
  SHOW = 'show',
  HIDE = 'hide',
  NONE = 'none'
}

export const setControllerWidth = (width: number = 0) => {
  broadcast({
    topic: 'set-frame-width',
    message: {
      width: `${width}px`,
      name: 'controller'
    }
  })
}

export const setControllerDimensions = (height: number = 0, width: number = 0) => {
  broadcast({
    topic: 'set-frame-dimensions',
    message: {
      height: `${height}px`,
      name: 'controller',
      width: `${width}px`
    }
  })
}

const setControllerHeight =  (height: number = 0, intent=FrameToggleAction.NONE) => {
  broadcast({
    topic: 'set-frame-height',
    message: {
      height: `${height}px`,
      name: 'controller',
      max: false,
      intent
    }
  })
}

export const hideWidgetController = async () => {
  const { data: controllerHeight } = await broadcast({
    topic: 'get-frame-height',
    message: {
      name: 'controller'
    }
  })

  if (controllerHeight === "0px") {
    return
  }

  setControllerHeight(0, FrameToggleAction.HIDE)
}
export const showWidgetController = async () => {
  const { data: controllerHeight } = await broadcast({
    topic: 'get-frame-height',
    message: {
      name: 'controller'
    }
  })

  if (controllerHeight !== "0px") {
    return
  }

  setControllerHeight(DEFAULT_WIDGET_ICON_HEIGHT, FrameToggleAction.SHOW)
}

export const resetControllerSize = () => {
  setControllerHeight(DEFAULT_WIDGET_ICON_HEIGHT)
  setControllerWidth(DEFAULT_WIDGET_ICON_WIDTH)
}
